import axios from 'axios'

const state = {
    list: [],
    load: true,
    dataUploaded: false,
    error: false,
    errorText: '',
};
const mutations = {
    add(state, item) {
        state.list.push(item);
    },
    err(state, text) {
        state.error = true;
        state.errorText = text;
        state.load = false;
        state.dataUploaded = false;
    }
};
const actions = {
    get_list(context) {
        if (context.state.dataUploaded) return;
        context.state.load = true;
        context.state.dataUploaded = true;
        axios({
            method: 'post',
            url: '/tourclient/masterAgent/dictionary/serviceClass/list',
            data: {
                request: JSON.stringify({}),
            }
        }).then(r => {
            if (r.data.ResultQueryInfo.HasError) {
                context.dispatch('error', {status: r.status, text: r.data.ResultQueryInfo.UserMessages}, {root: true});
                return;
            }
            r.data.Items.forEach(item => {
                item.value = item.Id;
                item.label = item.Name;
                context.commit('add', item);
            });
            context.state.load = false;
        }).catch(e => {
            context.dispatch('error', e, {root: true});
        });
    },
    re_list(context) {
        context.state.error = false;
        context.state.errorText = '';
        context.state.load = false;
        context.state.dataUploaded = false;
        context.dispatch('get_list');
    },
    set_item({commit}, item) {
        commit('add', item);
    }
};
const getters = {
    getById: (state, getters) => id => {
        if (!state.list.length) return null;
        return state.list.filter(i => {
            return i.value === id;
        })[0] || {};
    },
    getName: (state, getters) => id => {
        if (!state.list.length) return null;
        let a = state.list.filter(i => {
            return i.value === id;
        })[0];
        return a ? a.Name : '';
    },
    sort_list: (state) => {
        if (!state.list || !state.list.length) return [];
        return state.list.sort((a, b) => {
            return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
        });
    },
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
